import NotificationMediumTag from './NotificationMediumTag.component';

export default NotificationMediumTag;
